import { HttpParams } from '@angular/common/http';

/**
 * Converts a query object into HTTP parameters.
 *
 * Omits top-level undefined and empty-string values, while preserving
 * zero and false. Serializes top-level null as the literal string "null".
 * Arrays produce repeated parameters in their original order;
 * empty arrays produce no parameters. Array items must be non-null and are
 * serialized as-is using toString(), including empty strings.
 *
 * @param query - Query fields containing scalar values or arrays of values.
 * @returns A new HttpParams instance containing the serialized query fields.
 *
 * @example
 * buildHttpParams({ storeId: [1, 2], page: 0, search: '' });
 * // 'storeId=1&storeId=2&page=0'
 */
export function buildHttpParams(query: Record<string, any>): HttpParams {
  let params = new HttpParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === '') return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        params = params.append(key, item.toString());
      });
    } else {
      params = params.set(key, value === null ? 'null' : value.toString());
    }
  });

  return params;
}
